import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVolumeMinimum: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconVolumeMinimum"><Path d="M13 3.07104V20.9289L5.74656 17H1V6.99999H5.74656L13 3.07104Z" fill="currentColor"/><Path d="M14.1212 9.87881C14.6652 10.4228 14.9999 11.1714 14.9999 12.0001C14.9999 12.8288 14.6652 13.5775 14.1212 14.1215L15.5354 15.5357C16.4392 14.6319 16.9999 13.3806 16.9999 12.0001C16.9999 10.6197 16.4392 9.36833 15.5354 8.4646L14.1212 9.87881Z" fill="currentColor"/></CentralIconBase>;
});

export default IconVolumeMinimum;
